import * as React from "react";
import { useEffect, useState } from "react";
import * as Immutable from "immutable";
import i18n from "i18n";
import { useTranslation } from "react-i18next";
import SectionComponent from "components/common/Section/SectionComponent";
import { LinkContainer, ReadOnlyFormGroup, Spinner } from "components/common";
import Routes from "routing/Routes";
import { Button, Alert, ButtonToolbar } from "components/bootstrap";
import { loadGroupSync } from "authentication/api/groupSync";
import TriggerTeamSyncButton from "authentication/components/TriggerTeamSyncButton";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
import TriggerTeamSyncResponse from "authentication/components/directoryServices/TriggerTeamSyncResponse";
import LicenseCheck from "license/LicenseCheck";
import OidcConfigSection from "authentication/components/oidc/config/components/OidcConfigSection";
const getRolesList = (roles, defaultRolesIds) => {
  if (!defaultRolesIds || defaultRolesIds.size === 0) {
    return null;
  }
  const defaultRolesNames = defaultRolesIds.map((roleId) => {
    var _a;
    return (_a = roles.find((role) => role.id === roleId)) == null ? void 0 : _a.name;
  });
  return defaultRolesNames.join(", ");
};
export const getReadableSelectionType = (selectionType) => {
  switch (selectionType) {
    case "all":
      return i18n.t("oidc.group_sync_section.selection_types.all", { ns: "enterprise_authentication" });
    case "include":
      return i18n.t("oidc.group_sync_section.selection_types.include", { ns: "enterprise_authentication" });
    case "exclude":
      return i18n.t("oidc.group_sync_section.selection_types.exclude", { ns: "enterprise_authentication" });
    default:
      return selectionType;
  }
};
const GroupSyncSection = ({ authenticationBackend, roles }) => {
  const { t } = useTranslation("enterprise_authentication");
  const {
    id,
    title: backendTitle,
    config: { type }
  } = authenticationBackend;
  const [groupSyncBackend, setGroupSyncBackend] = useState();
  const [finishedLoading, setFinishedLoading] = useState(false);
  const [triggerSyncResponse, setTriggerSyncResponse] = useState();
  useEffect(() => {
    loadGroupSync(id).then((result) => {
      setGroupSyncBackend(result == null ? void 0 : result.backend);
    }).catch(() => {
      setGroupSyncBackend(void 0);
    }).finally(() => {
      setFinishedLoading(true);
    });
  }, [id]);
  if (!finishedLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const { defaultRoles, selectionType, selection = Immutable.Set() } = groupSyncBackend || {};
  const rolesList = defaultRoles && defaultRoles.size >= 1 ? getRolesList(roles, defaultRoles) : null;
  if (type !== OKTA_TYPE_KEY) {
    return /* @__PURE__ */ React.createElement(
      OidcConfigSection,
      {
        backendId: id,
        groupSyncBackend,
        getReadableSelectionType
      }
    );
  }
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: t("oidc.group_sync_section.title"),
      headerActions: /* @__PURE__ */ React.createElement(ButtonToolbar, null, groupSyncBackend && /* @__PURE__ */ React.createElement(TriggerTeamSyncButton, { backendId: id, backendTitle, setResponse: setTriggerSyncResponse }), /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.edit(id, "group_sync") }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small" }, t("oidc.group_sync_section.edit"))))
    },
    triggerSyncResponse && /* @__PURE__ */ React.createElement(TriggerTeamSyncResponse, { response: triggerSyncResponse }),
    groupSyncBackend ? /* @__PURE__ */ React.createElement(LicenseCheck, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("oidc.group_sync_section.team_default_roles"), value: rolesList }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("oidc.group_sync_section.okta_api_token"), value: "************" }), /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("oidc.group_sync_section.selection_type"),
        value: getReadableSelectionType(selectionType)
      }
    ), selectionType !== "all" && /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("oidc.group_sync_section.selected_groups"),
        value: t("oidc.group_sync_section.selected_groups_count", { size: selection.size })
      }
    )) : /* @__PURE__ */ React.createElement(Alert, null, t("oidc.group_sync_section.not_configured"))
  );
};
export default GroupSyncSection;
